/**
 * How the storefront writes a time (ORDR-118).
 *
 * An instant is formatted in the LOCATION's zone, from the payload's
 * `timezone`, never the browser's: a diner in another zone looking at a
 * location's cutoff needs the location's clock.
 */

const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** "Sat 01:30", in `timeZone`. The zone is required: there is no default. */
export function formatInstant(iso: string, timeZone: string): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone,
    weekday: "short",
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(new Date(iso));
}

/** "01:30", in `timeZone`, or the browser's when the location's is unknown. */
export function formatClock(iso: string, timeZone: string | undefined): string {
  return new Intl.DateTimeFormat("en-CA", {
    ...(timeZone === undefined ? {} : { timeZone }),
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(new Date(iso));
}

/** `day_of_week` as the schedule sends it: 0 is Monday. */
export function dayName(dayOfWeek: number): string {
  return DAYS[dayOfWeek] ?? `Day ${dayOfWeek}`;
}

/** "24 Dec" from "2026-12-24", read as a calendar date with no zone arithmetic. */
export function formatDate(isoDate: string): string {
  const [, month, day] = isoDate.split("-");
  const monthName = MONTHS[Number(month) - 1];
  return monthName === undefined || day === undefined ? isoDate : `${Number(day)} ${monthName}`;
}
